"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("../config"));
var core_1 = require("@eres/core");
function getAllImages(propertyId, isFreeHold) {
    return rest_1.httpGet(config_1.default.propertyImagesApi().endPoint() + "files/" + propertyId + "?isfreehold=" + isFreeHold);
}
exports.getAllImages = getAllImages;
function uploadImage(req, data, headers) {
    return rest_1.httpPostRaw(config_1.default.propertyImagesApi().endPoint() + "files/" + req.source + "/props/" + req.propertyId + "/?isfreehold=" + req.isFreeHold, data, headers);
}
exports.uploadImage = uploadImage;
function deleteImage(req) {
    return rest_1.httpDelete(config_1.default.propertyImagesApi().endPoint() + "files/" + req.source + "/props/" + req.propertyId + "/" + req.id + "?isfreehold=" + req.isFreeHold);
}
exports.deleteImage = deleteImage;
function setDefaultImage(req) {
    return rest_1.httpPut(config_1.default.propertyImagesApi().endPoint() + "files/" + req.source + "/props/" + req.propertyId + "/" + req.id + "?isfreehold=" + req.isFreeHold);
}
exports.setDefaultImage = setDefaultImage;
function getUploadImageUrl() {
    return config_1.default.propertyImagesApi().endPoint() + "files/(bcs|wallet)/props/[0-9]+/\\?isfreehold=(true|false)";
}
exports.getUploadImageUrl = getUploadImageUrl;
function getDefaultImageUrl(propertyId, isFreeHold) {
    return config_1.default.propertyImagesApi().endPoint() + "files/" + propertyId + "/default?isfreehold=" + isFreeHold;
}
exports.getDefaultImageUrl = getDefaultImageUrl;
function getImageUrl(req) {
    return config_1.default.propertyImagesApi().endPoint() + "files/" + req.source + "/" + req.propertyId + "/" + req.id + "?isfreehold=" + req.isFreeHold;
}
exports.getImageUrl = getImageUrl;
function exToMessage(e) {
    if (e.type === "webservice_error") {
        if (e.source && e.source.json) {
            return e.source.json().then(function (msg) {
                var r = msg;
                var error;
                var apiError = r && r.error;
                var source;
                if (apiError) {
                    source = apiError.src;
                    error = core_1.LocaleUtil.getLocalValue(apiError);
                    if (core_1.StringUtil.isEmptyStringOrNull(error)) {
                        error = apiError.desc;
                    }
                    if (core_1.StringUtil.isEmptyStringOrNull(error)) {
                        error = apiError.code;
                    }
                }
                if (core_1.StringUtil.isEmptyStringOrNull(error) && msg && msg.message) {
                    error = msg.message;
                }
                if (core_1.StringUtil.isEmptyStringOrNull(error)) {
                    error = e.toString();
                }
                return Promise.resolve({ error: error, content: msg, src: source });
            }).catch(function () {
                return Promise.resolve({ error: e.toString() });
            });
        }
    }
    return Promise.resolve({ error: e.toString() });
}
exports.exToMessage = exToMessage;
